'use strict';

const bannerCarouselA11y = require('friartux/components/bannerCarouselA11y');

const SELECTORS = {
  headerPretextBanner: '.global-campaign-banners-header',
  slide: '.banner-item',
  track: '.js-campaign-track'
};

function buildTrack($root) {
  // If track already exists (prevent double init), reuse it.
  const $existing = $root.find(SELECTORS.track).first();
  if ($existing.length) return $existing[0];

  // Find all banner slides (wherever they live inside the header).
  const $slides = $root.find(SELECTORS.slide);
  if (!$slides.length) return null;

  // Create a dedicated track INSIDE the header (no outside moves).
  const $track = $('<div class="js-campaign-track"></div>');

  // First child, where the slides already were: the geolocation message that follows
  // them in the banner must keep rendering after them, not before.
  $root.prepend($track);

  // Move only the slides into the track, preserving visual order.
  $slides.appendTo($track);

  return $track[0];
}

const initEvents = () => {
  const { tns } = require('tiny-slider');
  const $header = $(SELECTORS.headerPretextBanner);
  if (!$header.length) return;

  // Build a local track for the slider without restructuring the header.
  const trackEl = buildTrack($header);
  if (!trackEl) return; // nothing to slide

  // Initialize tiny-slider on the track only.
  const campaignSlider = tns({
    container: trackEl,
    items: 1,
    slideBy: 1,
    axis: 'vertical',
    swipeAngle: true,
    speed: 400,
    autoplayTimeout: 6000,
    mouseDrag: true,
    autoplay: true,
    nav: false,
    arrows: false,
    controls: false,
    autoplayButton: false,         // playback is owned by bannerCarouselA11y
    autoplayButtonOutput: false,   // do not inject extra buttons
    rewind: false,
    gutter: 0,
    autoHeight: false
  });

  // Adds the pause/play and previous/next controls, keeps the tab order on the slide
  // that is actually on screen, names the generic "View Details" links after their own
  // banner message, and holds the rotation while the banner has focus or the pointer.
  // See components/bannerCarouselA11y.
  bannerCarouselA11y.init(campaignSlider, {
    // Hover holds the rotation only over the sliding content: the banner bar is full
    // width, so crossing it is something that happens on the way to the nav.
    $hoverScope: $(trackEl)
  });
};

module.exports = () => {
  initEvents();
};